import { startOfDay } from 'date-fns';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const dateToISOWithTimezone = (date: Date, tz: string): string => {
  return zonedTimeToUtc(date, tz).toISOString();
};

const dateFromISOWithTimezone = (value: string, tz: string): Date => {
  return utcToZonedTime(new Date(value), tz);
};

const dateFromISOWithProjectTimezone = (
  value: string,
  timezone: string | null | undefined
): Date => {
  if (!timezone) {
    return new Date(value);
  }

  return dateFromISOWithTimezone(value, timezone);
};

const dateToISOWithProjectTimezone = (
  date: Date,
  timezone: string | null | undefined
): string => {
  if (!timezone) {
    return date.toISOString();
  }

  return dateToISOWithTimezone(startOfDay(date), timezone);
};

export {
  dateFromISOWithProjectTimezone,
  dateFromISOWithTimezone,
  dateToISOWithProjectTimezone,
  dateToISOWithTimezone
};
